import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import DailyBriefingView from '../components/screens/DailyBriefingView';
import { useDailyBriefing } from '../hooks/useDailyBriefing';

function DailyBriefingPage({ auth }) {
  const navigate = useNavigate();
  const {
    briefing,
    filters,
    status,
    isLoading,
    refreshBriefing,
    updateBriefingFilter,
    completeBriefingTask,
  } = useDailyBriefing(auth.currentUser);

  const openBriefingItem = useCallback(
    (item) => {
      if (!item?.sourceId) return;

      if (item.sourceType === 'calendar') {
        navigate(`/calendar?focusEventId=${encodeURIComponent(item.sourceId)}`);
      } else if (item.sourceType === 'task') {
        const query = new URLSearchParams({ focusTaskId: item.sourceId });
        if (item.itemKind === 'routine') query.set('view', 'routine');
        navigate(`/tasks?${query.toString()}`);
      }
    },
    [navigate]
  );

  return (
    <DailyBriefingView
      briefing={briefing}
      filters={filters}
      status={status}
      isLoading={isLoading}
      onFilterChange={updateBriefingFilter}
      onRefresh={refreshBriefing}
      onOpenItem={openBriefingItem}
      onCompleteTask={completeBriefingTask}
    />
  );
}

export default DailyBriefingPage;
